(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/defaults', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/defaults'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defaults, global.convert);
    global.defaults = mod.exports;
  }
})(this, function (exports, _defaults2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.defaults = undefined;

  var _defaults3 = _interopRequireDefault(_defaults2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object assigning own and inherited enumerable string keyed properties of source objects to the destination object for all destination properties that resolve to <code>undefined</code>.<br >
   * Source objects are applied from left to right. Once a property is set, additional values of the same property are ignored.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Object} [sources] The source objects.
   * @return {Object} Returns the updated object.
   * @example defaults({ nested: { a: 1, b: 2 } }, 'nested', { b: 3, c: 4 }) // => { nested: { a:1, b: 2, c: 4 } }
   * @see {@link https://lodash.com/docs#defaults|lodash.defaults} for more information.
   * @since 0.3.0
   */
  var defaults = (0, _convert.convert)(_defaults3.default);
  exports.defaults = defaults;
  exports.default = defaults;
});